import { log } from '@/logger/logger';
import { getAxiosInstance } from '@/services/axiosConfig';

const logger = log.getLogger('workspaceSettings');
const axiosInstance = getAxiosInstance();

interface CustomerPortalSessionParams {
  workspaceId: string;
  returnUrl: string;
  signal?: AbortSignal;
}

export const getCustomerPortalSession = async ({
  workspaceId,
  returnUrl,
  signal,
}: CustomerPortalSessionParams): Promise<string> => {
  try {
    const response = await axiosInstance.post<{ link: string }>(
      `/v1/workspaces/${workspaceId}/subscriptions/customer-portal-session`,
      { returnUrl },
      { signal },
    );
    return response.data.link;
  } catch (error) {
    logger.warn('Error requesting manage payments link', error);
    throw error;
  }
};

export const downloadCreditsReport = async (startDate?: Date): Promise<string> => {
  try {
    const response = await axiosInstance.post<string>('/v1/analytics/usage-report', {
      ...(startDate !== undefined && { startDate }),
    });
    return response.data;
  } catch (error) {
    logger.error('Error downloading credits report:', error);
    throw error;
  }
};
